<template>
  <div
    :class="[
      'jlxk-audio-or-video-detail',
      { 'jlxk-audio-or-video-alter-detail': isCanAlter }
    ]"
  >
    <div class="left">
      <video-player
        v-if="isVideo"
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @ready="playerReadied"
      />
      <div
        class="audio-container"
        v-else
      >
        <audio
          :src="vgaDetail.url"
          controls
          ref="audio"
          autoplay="true"
        />
      </div>
      <div class="intro">
        <div class="intro-item">
          <label>{{ labelTitle }}名称：</label>
          <div
            v-show="!isEditTitle"
            class="intro-item_text"
          >
            <span class="intro-item_name">{{ vgaDetail.name }}</span>
            <i
              class="icon jlxk-audio-video-detail-alter"
              @click="isEditTitle = true"
            />
          </div>
          <div
            class="edit-box"
            v-show="isEditTitle"
          >
            <el-input
              v-model="vgaDetail.name"
              maxlength="30"
            />
            <el-button
              type="primary"
              @click="handleCommand({ flag: 'title' })"
            >
              确定
            </el-button>
          </div>
        </div>
        <div class="intro-item">
          <label>{{ labelTitle }}摘要：</label>
          <div
            v-show="!isEditAbstract"
            class="intro-item_text"
          >
            <span class="intro-item_name">{{
              vgaDetail.abstract || "暂无摘要"
            }}</span>
            <i
              class="icon jlxk-audio-video-detail-alter"
              @click="handleAlterAbstract"
            />
          </div>
          <div
            class="edit-box edit-abstract-box"
            v-show="isEditAbstract"
          >
            <el-input
              v-model="editabstract"
              maxlength="500"
              type="textarea"
              autocomplete="off"
              resize="none"
            />
            <span>最多可输入500个字</span>
            <div class="btn">
              <el-button
                type="primary"
                @click="handleCommand({ flag: 'abstract' })"
              >
                确定
              </el-button>
              <el-button @click="isEditAbstract = false">
                取消
              </el-button>
            </div>
          </div>
        </div>
        <div class="line-box">
          <div class="intro-item">
            <label>时长：</label>{{ formatDuration(vgaDetail.duration) }}
          </div>
          <div class="intro-item">
            <label>格式：</label>{{ vgaDetail.format }}
          </div>
          <div class="intro-item">
            <label>占用空间：</label>{{ sizeTotal | videoSize }}
          </div>
        </div>
      </div>
      <el-table
        :data="materielAddressList"
        tooltip-effect="dark"
        style="width: 100%"
        border
      >
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center"
        />
        <el-table-column
          label="转码模板"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.t_name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="t_format"
          label="格式"
          align="center"
          width="80"
        />
        <el-table-column
          label="码率"
          align="center"
          width="117"
        >
          <template slot-scope="{ row }">
            {{ row.bitrate }}Kbps
          </template>
        </el-table-column>
        <el-table-column
          prop="t_codec"
          label="编码格式"
          align="center"
          width="90"
        />
        <el-table-column
          label="存储大小"
          align="center"
          width="90"
        >
          <template
            v-if="row.size"
            slot-scope="{ row }"
          >
            {{ row.size | videoSize }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="90"
        >
          <template slot-scope="{ row, $index }">
            <el-tooltip
              class="copy"
              effect="dark"
              content="点击复制"
              placement="top"
            >
              <span
                v-clipboard:copy="row.fileUrl"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                <i
                  class="icon jlxk-video-copy"
                /></span>
            </el-tooltip>
            <el-tooltip
              class="download"
              effect="dark"
              content="点击下载"
              placement="top"
            >
              <i
                class="icon jlxk-video-download"
                @click="handleDownLoad(row)"
              />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-tabs v-model="currentTab">
      <el-tab-pane
        v-for="item in showTabList"
        :key="item.name"
        :label="item.label === 'tag' ? `${labelTitle}${item.name}` : item.name"
        :name="item.label"
      >
        <keep-alive>
          <components
            v-show="currentTab === item.label"
            :is="item.label"
            :ref="item.label"
            :detail="vgaDetail"
            @updateDetail="handleCommand"
            @handlePlay="handlePlay"
            @checkReback="checkReback"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <checkDialog
      ref="checkDialog"
      :type="vgaDetail.type"
      :is-show-check-list="false"
      :checked-list="checkedListData"
      @handleVideoCheck="getMamAICheck"
    />
  </div>
</template>

<script>
import tag from './components/tag'
import detection from './components/detection'
import peopleRecognition from './components/peopleRecognition'
import voiceRecognition from './components/voiceRecognition'
import textRecognition from './components/textRecognition'
import checkDialog from '@views/jlxk/review/components/checkDialog'
import APIS from '@apis/jlxk'
import { fileDownLoad } from '@common/util.js'
export default {
  name: 'Detail',
  props: {},
  components: {
    tag,
    detection,
    voiceRecognition,
    textRecognition,
    peopleRecognition,
    checkDialog
  },
  data() {
    return {
      isEditTitle: false,
      isEditAbstract: false,
      editabstract: null,
      currentTab: 'tag',
      tabList: [
        {
          name: '标签',
          label: 'tag'
        },
        {
          name: '智能检测',
          label: 'detection'
        },
        {
          name: '人物识别',
          label: 'peopleRecognition'
        },
        {
          name: '语音识别',
          label: 'voiceRecognition'
        },
        {
          name: '文字识别',
          label: 'textRecognition'
        }
      ],
      audioList: [
        {
          name: '智能检测',
          label: 'detection'
        },
        {
          name: '语音识别',
          label: 'voiceRecognition'
        }
      ],
      vgaDetail: {
        name: '',
        abstract: '',
        url: '',
        duration: '',
        type: 'video',
        tag: [], // 标签
        ocr: [],
        txt: [], // 语音识别
        faceList: [],
        attachment: {},
        format: '',
        transCodeFiles: [],
        checkStatus: 0,
        checkResult: []
      },
      tableData: [],
      thead: [
        '序号',
        '转码模板',
        '格式',
        '码率',
        '编码格式',
        '存储大小',
        '操作'
      ],
      tAttr: ['index', '', 'format', ''],
      materielAddressList: [],
      playerOptions: {
        controls: true,
        // playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: true, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      playtimes: '',
      checkedListData: []
    }
  },
  filters: {
    // 创建时间
    formatCreatedTime: function(time) {
      return moment(time).format('YYYY/MM/DD HH:mm')
    },
    videoSize: function(value) {
      value = Number(value)
      if (value < 1024) {
        return value + 'B'
      }
      if (value >= 1024 && value < 1024 * 1024) {
        return (value / 1024).toFixed(2) + 'K'
      }
      if (value >= 1024 * 1024 && value < 1024 * 1024 * 1024) {
        return (value / 1024 / 1024).toFixed(2) + 'M'
      }
      if (value >= 1024 * 1024 * 1024) {
        return (value / 1024 / 1024 / 1024).toFixed(2) + 'G'
      }
    }
  },
  computed: {
    currentIndex() {
      return this.$store.state.currentIndex
    },
    isVideo() {
      return this.vgaDetail.type === 'video'
    },
    labelTitle() {
      return this.isVideo ? '视频' : '音频'
    },
    sizeTotal() {
      let size = 0
      if (this.materielAddressList && this.materielAddressList.length !== 0) {
        this.materielAddressList.forEach(item => {
          if (!item || !item.size) return false
          size += item.size
        })
      }
      return size
    },
    player() {
      return this.$refs.videoPlayer.player
    },
    showTabList() {
      return this.isVideo ? this.tabList : this.audioList
    },
    isCanAlter() {
      return this.$route.query.isAlter === 'true'
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [''])
    this.getMamAISelectVideo()
  },
  methods: {
    // 获取音视频详细信息
    async getMamAISelectVideo() {
      let params = {
        id: this.$route.query.id,
        docId: this.$route.query.docId
      }
      let { status, data } = await APIS.postMamAISelectVideo({ data: params })
      if (status === 0 && data) {
        this.checkedListData = [{
          id: this.$route.query.docId,
          attachments: [data.attachment]
        }]
        let fileName = data.mam_fileName || data.attachment.name
        let audioArray = data.attachment.o_uri.split('.')
        let array = fileName.split('.')
        this.vgaDetail = {
          name: data.SYS_TOPIC || data.attachment.name.split('.')[0],
          abstract: data.mam_content,
          url:
            data.mam_transUrl || data.mam_resourceUrl || data.attachment.b_uri,
          duration: data.mam_duration || data.attachment.duration,
          type: data.mamType || data.attachment.type,
          tag: data.tag || [],
          ocr: data.ocr || [],
          txt: data.txt || [],
          faceList: data.face || [],
          attachment: data.attachment,
          format:
            data.attachment.type === 'audio'
              ? (data.audio && data.audio.format) ||
                audioArray[audioArray.length - 1]
              : (data.video && data.video.format) || array[array.length - 1], // 格式
          transCodeFiles: data.transCodeFiles || [], // 转码格式
          checkStatus: data.status, // 1检测中;2检测成功;3检测失败,
          checkResult: []
        }
        if (this.isVideo) {
          this.playerOptions.sources = [
            {
              type: 'video/mp4',
              src: this.vgaDetail.url
            }
          ]
          let check_list = ['porn', 'terrorism', 'live', 'ad']
          check_list.forEach(item => {
            if (data[item]) {
              this.vgaDetail.checkResult.push(data[item])
            }
          })
        } else {
          if (data.antispam) {
            this.vgaDetail.checkResult.push(data.antispam)
          }
          this.currentTab = 'detection'
        }
        let list = []
        let originalMaterial = {
          t_name: '源文件',
          t_format: this.vgaDetail.format,
          bitrate: data.video && data.video.bitRate,
          fileUrl: this.vgaDetail.url,
          t_codec: data.video && data.video.format,
          size: (data.video && data.video.size) || data.attachment.size,
          id: data.sourceId,
          sourceFlag: data.sourceFlag
        }
        if (!data.sourceFlag) {
          list.push(originalMaterial)
        }
        this.materielAddressList = data.transCodeFiles
          ? list.concat(data.transCodeFiles)
          : list
      }
    },
    // 音视频修改
    async getMamAIUpdateVideo(updateParams) {
      let params = Object.assign(
        {},
        {
          id: this.$route.query.id,
          docId: this.$route.query.docId,
          type: this.vgaDetail.type,
          attachment: this.vgaDetail.attachment,
          SYS_TOPIC: this.vgaDetail.name,
          mam_content: this.isEditAbstract
            ? this.editabstract
            : this.vgaDetail.abstract
        },
        updateParams
      )
      let { status, message } = await APIS.postMamAIUpdateVideo({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0) {
        this.vgaDetail.abstract = params.mam_content
        this.getMamAISelectVideo()
        this.isEditTitle = false
        this.isEditAbstract = false
        this.editabstract = null
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    // 音视频检测
    async getMamAICheck(params) {
      let { status, message } = await APIS.postMamAICheck({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0) {
        let flag = params.type === 'audio' ? '音频' : '视频'
        this.global_.handleMessageTips(`检测任务已创建，请稍候在${flag}详情中查看分析结果`, 'success')
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    // 播放时长处理
    formatDuration(duration) {
      // 后台传的单位是秒
      let res = ''
      let hour, minute, second
      hour = Math.floor(duration / 3600) % 60
      minute = Math.floor(duration / 60) % 60
      second = Math.floor(duration) % 60
      if (hour !== 0) {
        res = hour + ':' + (minute < 10 ? '0' + minute : minute) + ':' + second
      } else {
        res =
          (minute !== 0 ? minute : '00') +
          ':' +
          (second < 10 ? '0' + second : second)
      }
      return res
    },
    copySuccess() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    copyError() {},
    handleDownLoad(value) {
      let arr = value.fileUrl.split('/')
      let fileName = arr[arr.length - 1]
      let parmas = {
        path: value.fileUrl,
        fileName: fileName
      }
      fileDownLoad('/api/mam/download', parmas, fileName, 'get')
    },
    handleCommand({ flag, content }) {
      let updateParams = {}
      if (flag === 'title') {
        if (this.vgaDetail.name === '') {
          this.global_.handleMessageTips('请输入名称', 'error')
          return false
        }
      }
      if (flag === 'tag') {
        updateParams = {
          tag: content
        }
      }
      if (flag === 'txt') {
        updateParams = {
          txt: content
        }
      }
      this.getMamAIUpdateVideo(updateParams)
    },
    // 摘要修改
    handleAlterAbstract() {
      this.isEditAbstract = true
      this.editabstract = this.vgaDetail.abstract
    },
    // 重新检测
    checkReback() {
      this.$refs.checkDialog.$refs.videoCheckDialog.cyDialogCommon = true
    },
    /**
     * 处理播放器播放
     * @param time播放时间
     */
    handlePlay(time) {
      this.playtimes =
        typeof time === 'number' ? time : this.getSecondTime(time)
      if (this.isVideo) {
        this.$refs.videoPlayer.player.play()
      } else {
        this.$refs.audio.currentTime = this.playtimes
      }
    },
    // 转换成秒
    getSecondTime(time) {
      let timeArr = time.split(':')
      return (
        Number(timeArr[0]) * 3600 + Number(timeArr[1]) * 60 + Number(timeArr[2])
      )
    },
    playerReadied(player, playtimes) {
      player.currentTime(playtimes)
    }
  },
  watch: {
    playtimes(val, oldVal) {
      this.playerReadied(this.$refs.videoPlayer.player, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-audio-or-video-detail {
  display: flex;
  justify-content: space-between;
  @extend .comBackground;
  margin-top: 30px;
  padding: 20px 30px;
  min-height: calc(100vh - 100px);
  .left {
    width: 600px;
    video {
      width: 100%;
      height: 300px;
      background-color: #000;
    }
    .intro {
      margin-top: 5px;
      &-item {
        display: flex;
        font-size: 13px;
        margin-bottom: 6px;
        min-height: 30px;
        color: #666;
        &:first-child {
          align-items: center;
        }
        &_text {
          display: flex;
          align-items: center;
          i {
            flex-shrink: 0;
          }
        }
        .btn {
          margin-top: -30px;
          display: flex;
          justify-content: flex-end;
        }
        .edit-box {
          flex: 1;
          display: flex;
          &.edit-abstract-box {
            flex-direction: column;
          }
        }
        label {
          flex-shrink: 0;
          color: #333;
          line-height: 30px;
        }
        span {
          line-height: 30px;
        }
        i {
          visibility: hidden;
          margin-left: 10px;
          cursor: pointer;
        }
        .intro-item_name {
          font-size: 13px;
        }
        /deep/ .el-input,
        /deep/ .el-textarea {
          font-size: 13px;
          &__inner {
            font-family: founder_youhei_508R;
            background-color: #fff;
          }
        }
        /deep/ .el-textarea {
          margin-bottom: 10px;
          &__inner {
            height: 90px;
          }
        }
      }
      .line-box {
        display: flex;
        margin-bottom: 20px;
        .intro-item {
          align-items: center;
          margin-right: 40px;
        }
      }
    }
    /deep/ .el-table {
      &::before {
        display: none;
      }
      tr {
        td,
        th {
          font-size: 13px;
          border-color: #dcdcdc;
          .cell {
            padding: 0 10px;
            i {
              &.jlxk-video-copy {
                margin-right: 14px;
              }
              cursor: pointer;
            }
          }
        }
        th {
          color: #333;
          font-weight: normal;
          background: #f9f9f9;
          &.gutter {
            display: initial !important;
          }
        }
      }
      &--border {
        border-color: #dcdcdc;
        &::after {
          display: none;
        }
      }
    }
    .audio-container {
      position: relative;
      width: 600px;
      height: 300px;
      background: url("~@assets/imgs/jlxk/jlxk-audio-detail-bg.png");
      audio {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
    /deep/ .vjs-has-started .vjs-control-bar {
      opacity: 1 !important;
    }
    .audio-player {
      .vjs-tech {
        background: url("~@assets/imgs/jlxk/jlxk-audio-detail-bg.png");
      }
    }
    // .vjs-custom-skin {
    //   background: url("~@assets/imgs/jlxk/jlxk-audio-detail-bg.png");
    // }
  }
  /deep/ .el-tabs {
    width: 520px;
    &__header {
      margin: 0;
    }
    &__nav-wrap {
      &:after {
        height: 1px;
        background-color: #edf0f7;
      }
    }
    .el-timeline {
      margin-top: 20px;
      &-item {
        position: relative;
        padding-bottom: 15px;
        &__tail {
          position: absolute;
          left: 3px;
          height: 100%;
          border-left: 1px solid #dfdfdf;
        }
        &__node {
          position: absolute;
          left: 0;
          top: 3px;
          width: 7px;
          height: 7px;
          background-color: #4497ec;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &__timestamp {
          padding: 0 0 9px 20px;
          font-size: 13px;
        }
        &__content {
          margin-left: 13px;
        }
      }
    }
    .empty {
      margin: 70px auto 20px;
      text-align: center;
      h6 {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
      }
    }
  }
  &.jlxk-audio-or-video-alter-detail {
    .left {
      .intro {
        &-item {
          &_text {
            &:hover {
              i {
                visibility: visible;
              }
            }
          }
        }
      }
    }
    /deep/ .voice-recongnition-container {
      .el-timeline {
        &-item {
          &__content {
            &:hover {
              i {
                visibility: visible;
              }
            }
          }
        }
      }
    }
  }
}
</style>
